(function() {
  'use strict';

  var root = document.getElementById('dl-puppy-roadmap');
  if (!root) return;
  if (root.dataset.dlprInit === 'true') return;
  root.dataset.dlprInit = 'true';

  if (!document.getElementById('dlpr-google-fonts')) {
    var link = document.createElement('link');
    link.id = 'dlpr-google-fonts';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,600;1,400&family=DM+Sans:wght@300;400;500;600;700&display=swap';
    document.head.appendChild(link);
  }

  var AGE_WINDOWS = [
  { id:1, label:"1–3 months", tag:"Foundation window", desc:"The golden window. Everything is easier when it starts here." },
  { id:2, label:"4–6 months", tag:"Routine window",    desc:"Lock in routine and first professional exposure." },
  { id:3, label:"7–9 months", tag:"Catch-up window",   desc:"Habits are forming. A great time to fill any gaps." },
  { id:4, label:"10–12 months", tag:"Honest mode",     desc:"A little later to start — and still absolutely worth starting." },
];
  var COAT_TRACKS = [
  { id:1, icon:"🌀", name:"Curly / Wool",
    examples:"Poodle, Labradoodle, Goldendoodle, Cavoodle, Cockapoo, Bichon Frise, Bernedoodle, Maltipoo, Aussiedoodle",
    summary:"Continuously growing coat that needs regular grooming — the earlier the routine starts, the easier it stays.",
    truth:"With this coat, starting early means both the coat and the dog stay manageable together." },
  { id:2, icon:"〰️", name:"Wavy / Fleece",
    examples:"Some Groodles, some Labradoodles, some Cavoodles, Bordoodle, Whoodle",
    summary:"Softer than wool, but still grooming-dependent — and easier to maintain when the routine starts early.",
    truth:"This coat looks low-maintenance early on — which is exactly why the routine is worth building before it's needed." },
  { id:3, icon:"✨", name:"Long / Silky",
    examples:"Maltese, Shih Tzu, Yorkshire Terrier, Cavalier KCS, Lhasa Apso, Havanese, Silky Terrier",
    summary:"Lies flat and looks innocent, but knots fast in friction zones once routine slips.",
    truth:"These coats look fine for a long time — which makes regular combing through friction zones easy to overlook." },
  { id:4, icon:"🌿", name:"Double / Shedding",
    examples:"Labrador, Golden Retriever, Husky, Border Collie, German Shepherd, Kelpie, Corgi, Samoyed",
    summary:"No clipping needed, but still needs brush depth, dryer tolerance, and a deshedding routine.",
    truth:"The coat doesn't need styling, but the handling still needs to be learned — bath, dryer, nails, table." },
  { id:5, icon:"⚡", name:"Short / Smooth",
    examples:"Staffy, Boxer, Dachshund, French Bulldog, Beagle, Weimaraner, Dalmatian, Whippet",
    summary:"Lowest coat-maintenance track — but handling, nails, baths, and restraint still need to be built early.",
    truth:"The coat is simple. The handling tolerance — nails, ears, baths, restraint — is where the early work pays off." },
];
  var MILESTONES = {
  1: [
    { id:"1-1", num:1, icon:"🤲", title:"Body Handling & Restraint", hideForAge:[],
      teaser:"This shapes every groom for the next 15 years.",
      why:"If the dog can't accept stillness and touch, nothing else in grooming works.",
      q1:{ text:"How does your puppy react when you hold gently under their chin and ask for brief stillness?",
        opts:[{t:"Completely relaxed, no resistance",e:"🌟",s:3},{t:"A bit wiggly but accepts it",e:"🐾",s:2},{t:"Pulls away, mouths, or resists",e:"😬",s:1},{t:"We haven't really practised this",e:"😅",s:0}]},
      q2:{ text:"Can you gently hold each paw for a few seconds while they stay calm?",
        opts:[{t:"Yes — all four paws, no problem",e:"✅",s:3},{t:"Most paws yes, one or two tricky",e:"🤔",s:2},{t:"They pull away most times",e:"😤",s:1},{t:"We haven't worked on this yet",e:"⏳",s:0}]},
      truth:"Early handling makes such a difference — even a few minutes a day in the first weeks builds real comfort.",
      consequence:"Building this early makes every other part of grooming easier down the line.",
      nextStep:"Start with 30-second sessions — chin hold, then paws, one at a time. Always stop before they resist." },

    { id:"1-2", num:2, icon:"👁️", title:"Face, Feet & Sensory Handling", hideForAge:[],
      teaser:"A lot of adult grooming stress starts right here.",
      why:"Face and feet work is what most owners skip. It's the first thing groomers need.",
      q1:{ text:"When you touch around the eyes, muzzle, and mouth — how does your puppy respond?",
        opts:[{t:"Calm and accepting",e:"😌",s:3},{t:"Slightly sensitive but manageable",e:"🙂",s:2},{t:"Turns away or resists",e:"😬",s:1},{t:"We mostly avoid this",e:"🚫",s:0}]},
      q2:{ text:"Have you touched individual nails and gently spread the toes?",
        opts:[{t:"Yes — regularly, no big deal",e:"🏆",s:3},{t:"A few times — mixed response",e:"👍",s:2},{t:"We tried and it was a fight",e:"😓",s:1},{t:"Not yet",e:"❌",s:0}]},
      truth:"Chin holds and foot handling are the two things that make every grooming appointment smoother — and they're easy to build at home.",
      consequence:"Face and feet handling, introduced early, makes every future appointment calmer for the dog.",
      nextStep:"One minute daily on face and feet — eyes, muzzle, toes. Always end before they protest." },

    { id:"1-3", num:3, icon:"🪮", title:"Brush & Comb to Skin", hideForAge:[],
      teaser:"Fluffing the surface isn't brushing. This is where coat health actually lives.",
      why:"Surface brushing hides what's underneath — and that's exactly where matting starts.",
      q1:{ text:"When you brush, are you working all the way through the coat — not just the top layer?",
        opts:[{t:"Yes — all the way through every time",e:"💯",s:3},{t:"Mostly, but I skip tricky spots",e:"🙂",s:2},{t:"Mostly surface brushing",e:"😬",s:1},{t:"No regular brush routine yet",e:"🤷",s:0}]},
      q2:{ text:"Do you check behind the ears, under the armpits, and around the collar area?",
        opts:[{t:"Yes — every single session",e:"✅",s:3},{t:"Sometimes, not always",e:"🔄",s:2},{t:"Rarely — those spots are hard",e:"😕",s:1},{t:"I didn't know these were the problem spots",e:"😯",s:0}]},
      truth:"Brushing the surface and combing all the way through are two different things — and both matter.",
      consequence:"Hidden matting in friction zones is the most common reason for emergency short clips.",
      nextStep:"Focus your next session entirely on ears, armpits, and collar area. Use a metal comb after the brush." },

    { id:"1-4", num:4, icon:"💨", title:"Bath & Dryer Exposure", hideForAge:[],
      teaser:"One of the most impactful things to introduce early — and one of the easiest to build when started gradually.",
      why:"Dryer tolerance is much easier to build gradually from the start than to introduce later.",
      q1:{ text:"Has your puppy been introduced to dryer sound near them?",
        opts:[{t:"Yes — completely unbothered",e:"😎",s:3},{t:"Yes — nervous but coping",e:"😐",s:2},{t:"Yes — clearly frightened",e:"😰",s:1},{t:"Not yet",e:"❌",s:0}]},
      q2:{ text:"Can airflow touch the coat while your puppy stays reasonably calm?",
        opts:[{t:"Yes — no real issue",e:"✨",s:3},{t:"Yes — with treats and support",e:"🍖",s:2},{t:"Only briefly before they struggle",e:"⚡",s:1},{t:"We haven't tried this yet",e:"🤔",s:0}]},
      truth:"Drying tolerance is taught, not built in — and it's never too late to introduce it gradually.",
      consequence:"A dog who's comfortable with the dryer makes every future groom quicker and calmer for everyone.",
      nextStep:"Dryer on in another room — just the sound, treats throughout. Move closer over several days. Never rush." },

    { id:"1-5", num:5, icon:"✂️", title:"First Professional Introduction", hideForAge:[1],
      teaser:"Not about the haircut. About the hello.",
      why:"The emotional memory of the first salon visit shapes every single groom that follows.",
      q1:{ text:"Has your puppy had a short professional grooming introduction yet?",
        opts:[{t:"Yes — and it went smoothly",e:"⭐",s:3},{t:"Yes — nervous but workable",e:"😕",s:2},{t:"Yes — quite stressful",e:"😢",s:1},{t:"Not yet",e:"📅",s:0}]},
      q2:{ text:"After that visit, how did your puppy seem?",
        opts:[{t:"Happy and normal afterwards",e:"🐶",s:3},{t:"Tired but settled quickly",e:"😴",s:2},{t:"Stressed or shutdown for a while",e:"😟",s:1},{t:"We haven't been yet",e:"⏳",s:0}]},
      truth:"An early first visit — kept short and calm — gives the dog a chance to learn the salon is a safe place.",
      consequence:"An early intro visit — kept short and positive — means the first real groom feels familiar, not new.",
      nextStep:"Book an intro visit — not a full groom. Short, calm, low pressure. Tell them it's the first time." },
  ],

  2: [
    { id:"2-1", num:1, icon:"🤲", title:"Body Handling & Restraint", hideForAge:[],
      teaser:"The same foundation as any groomed coat. The margin for error is slightly wider — not magically wide.",
      why:"Fleece dogs look forgiving. They aren't as forgiving as they look.",
      q1:{ text:"How does your puppy respond when you hold gently under the chin and ask for brief stillness?",
        opts:[{t:"Completely relaxed",e:"🌟",s:3},{t:"Wiggly but accepts it",e:"🐾",s:2},{t:"Pulls away or resists",e:"😬",s:1},{t:"We haven't really practised this",e:"😅",s:0}]},
      q2:{ text:"Can you hold each paw briefly while they stay reasonably settled?",
        opts:[{t:"Yes — all four, manageable",e:"✅",s:3},{t:"Most are fine, one or two tricky",e:"🤔",s:2},{t:"They resist most times",e:"😤",s:1},{t:"Not really practised yet",e:"⏳",s:0}]},
      truth:"Brushing gets most of the attention — but calm handling of feet, face, and chin is just as important.",
      consequence:"Fleece gives you a little more grace than wool. Not enough to be casual.",
      nextStep:"Daily: chin hold, paw hold, brief stillness. Keep it short. Always end on a calm moment." },

    { id:"2-2", num:2, icon:"👁️", title:"Face, Feet & Sensory Handling", hideForAge:[],
      teaser:"Fleece coats can hide the handling gaps — until they suddenly can't.",
      why:"The soft texture doesn't mean the dog is soft about being handled.",
      q1:{ text:"How does your puppy react to you touching around the eyes, muzzle, and mouth?",
        opts:[{t:"Calm and accepting",e:"😌",s:3},{t:"Slightly sensitive but manageable",e:"🙂",s:2},{t:"Turns away or resists",e:"😬",s:1},{t:"We avoid it",e:"🚫",s:0}]},
      q2:{ text:"Have you touched nails individually and spread the toes?",
        opts:[{t:"Yes — regularly",e:"🏆",s:3},{t:"A few times",e:"👍",s:2},{t:"Tried and it went badly",e:"😓",s:1},{t:"Not yet",e:"❌",s:0}]},
      truth:"Owners focus on the coat. Groomers focus on the dog.",
      consequence:"Face and feet handling built early becomes something the dog barely notices — which is exactly the goal.",
      nextStep:"Three minutes daily on face and feet. Go slow, use treats, stop before resistance." },

    { id:"2-3", num:3, icon:"🪮", title:"Comb Through Friction Zones", hideForAge:[],
      teaser:"This is where fleece coats catch owners by surprise.",
      why:"Friction zones tangle quietly — then suddenly become unworkable.",
      q1:{ text:"Do you comb through ears, armpits, chest, and collar area — not just the top layer?",
        opts:[{t:"Yes — every session",e:"✅",s:3},{t:"Usually, but not always",e:"🔄",s:2},{t:"Rarely",e:"😕",s:1},{t:"No real routine yet",e:"🤷",s:0}]},
      q2:{ text:"When you find a tangle — what usually happens?",
        opts:[{t:"I work it out gently and early",e:"🌟",s:3},{t:"I manage some but not all",e:"🙂",s:2},{t:"I tend to leave it too long",e:"😬",s:1},{t:"I don't notice until it's bad",e:"⚠️",s:0}]},
      truth:"This coat can look very manageable early on — which makes it easy to delay the routine until it's needed.",
      consequence:"Fleece coats stay manageable with regular combing — and the routine is much easier to keep than to rebuild.",
      nextStep:"Get a metal comb this week. Check ears, armpits, chest. If you find knots, work tip to root — never pull through." },

    { id:"2-4", num:4, icon:"💨", title:"Bath & Dryer Exposure", hideForAge:[],
      teaser:"Fleece and dryers need to become friends early.",
      why:"Dryer tolerance doesn't develop on its own — it has to be built.",
      q1:{ text:"Has your puppy been introduced to dryer sound near them?",
        opts:[{t:"Yes — completely fine",e:"😎",s:3},{t:"Nervous but coping",e:"😐",s:2},{t:"Clearly frightened",e:"😰",s:1},{t:"Not yet",e:"❌",s:0}]},
      q2:{ text:"Can airflow touch the coat while your puppy stays reasonably calm?",
        opts:[{t:"Yes — no real issue",e:"✨",s:3},{t:"Yes — with support",e:"🍖",s:2},{t:"Only briefly",e:"⚡",s:1},{t:"Not yet",e:"🤔",s:0}]},
      truth:"A calm shorter groom is always better than a beautiful stressful one.",
      consequence:"Dryer resistance turns routine appointments into ordeals for both dog and groomer.",
      nextStep:"Dryer on in another room this week — just the sound, treats throughout. Move closer over several sessions." },

    { id:"2-5", num:5, icon:"✂️", title:"First Professional Introduction", hideForAge:[1],
      teaser:"Fleece coats grow. A professional relationship needs to grow with them.",
      why:"Professional exposure early means the routine becomes predictable — not frightening.",
      q1:{ text:"Has your puppy had a short professional grooming introduction yet?",
        opts:[{t:"Yes — went well",e:"⭐",s:3},{t:"Yes — nervous but manageable",e:"😕",s:2},{t:"Yes — stressful",e:"😢",s:1},{t:"Not yet",e:"📅",s:0}]},
      q2:{ text:"Is your puppy now on a predictable grooming routine?",
        opts:[{t:"Yes — fully regular",e:"📆",s:3},{t:"Somewhat regular",e:"🔄",s:2},{t:"Very inconsistent",e:"😅",s:1},{t:"Not started yet",e:"⏳",s:0}]},
      truth:"Fleece gives you a little more grace than wool. Not enough to drift.",
      consequence:"Regular visits keep this coat in good shape — and make each appointment quicker and easier.",
      nextStep:"Book an intro appointment this week. Ask for short, calm, no pressure." },
  ],

  3: [
    { id:"3-1", num:1, icon:"🤲", title:"Daily Handling of Face, Feet, Ears & Tail", hideForAge:[],
      teaser:"These coats look gentle. The dogs still need to be handled properly.",
      why:"Once grooming feels uncomfortable, table behaviour follows fast.",
      q1:{ text:"Do you handle your puppy's ears, feet, face, and tail regularly?",
        opts:[{t:"Yes — daily or near-daily, very normal",e:"✅",s:3},{t:"A few times a week",e:"🔄",s:2},{t:"Occasionally — they dislike parts of it",e:"😬",s:1},{t:"Rarely or never",e:"🚫",s:0}]},
      q2:{ text:"Can you touch and comb feathered areas without your puppy trying to leave?",
        opts:[{t:"Yes — they tolerate it well",e:"🌟",s:3},{t:"Mostly — a few tricky spots",e:"🙂",s:2},{t:"They often try to move away",e:"😕",s:1},{t:"We haven't really done this",e:"⏳",s:0}]},
      truth:"These coats look fine for a long time — which makes regular combing through friction zones easy to overlook.",
      consequence:"Silky coats that weren't handled early become uncomfortable to groom — and that discomfort makes behaviour worse.",
      nextStep:"Start with the areas they accept most. Build to ears, chest, and feathering over days. Very short sessions only." },

    { id:"3-2", num:2, icon:"🪮", title:"Daily Brush-Outs", hideForAge:[],
      teaser:"Daily. Not weekly. Not when you notice tangles.",
      why:"With long silky coats, reactive brushing is always too late.",
      q1:{ text:"How often are you brushing?",
        opts:[{t:"Daily — every single day",e:"💯",s:3},{t:"Every couple of days",e:"👍",s:2},{t:"When I notice tangles",e:"🤷",s:1},{t:"Not regularly",e:"🚫",s:0}]},
      q2:{ text:"How long can your puppy stay comfortable during brushing?",
        opts:[{t:"As long as needed — they stay relaxed",e:"🏆",s:3},{t:"A few minutes comfortably",e:"🙂",s:2},{t:"Very short tolerance",e:"😅",s:1},{t:"They try to escape quickly",e:"😤",s:0}]},
      truth:"The goal is not perfection. The goal is a dog who can cope.",
      consequence:"Daily brushing keeps silky coats in great condition — and takes far less time than working through built-up tangles.",
      nextStep:"Start a daily two-minute brush regardless of whether you think they need it. The habit matters more than the session." },

    { id:"3-3", num:3, icon:"✨", title:"Friction Zone Combing", hideForAge:[],
      teaser:"This is where silky coats hide trouble — until they can't anymore.",
      why:"Ears, chest, belly, and feathering tangle quietly — regular combing through these areas keeps things easy.",
      q1:{ text:"Do you comb behind the ears, through the chest, belly, feathering, and legs specifically?",
        opts:[{t:"Yes — every session",e:"✅",s:3},{t:"Sometimes, not every time",e:"🔄",s:2},{t:"Rarely",e:"😬",s:1},{t:"I didn't know these were the main problem areas",e:"😯",s:0}]},
      q2:{ text:"When you find a small knot — what do you do?",
        opts:[{t:"Work it out gently and early",e:"🌟",s:3},{t:"Try to brush through it",e:"🙂",s:2},{t:"Leave it for later",e:"😅",s:1},{t:"Only notice it when it's already bad",e:"😬",s:0}]},
      truth:"A simple coat still needs bath tolerance, nail handling, and a dog who's comfortable being handled all over.",
      consequence:"Friction knots in silky coats make handling feel uncomfortable — and then the dog starts resisting the handling.",
      nextStep:"This week: comb specifically through ears, chest, belly, and feathering. Use fingers first on any knot." },

    { id:"3-4", num:4, icon:"💨", title:"Bath & Blow-Dry Tolerance", hideForAge:[],
      teaser:"Long coats and air drying don't work. This tolerance has to be built.",
      why:"A silky coat that air-dries often dries in tangles. Blow-dry tolerance is essential.",
      q1:{ text:"How does your puppy handle bath time?",
        opts:[{t:"Calm and completely normal",e:"😌",s:3},{t:"A bit wriggly but workable",e:"🙂",s:2},{t:"Clearly stressed",e:"😕",s:1},{t:"It is a battle",e:"😤",s:0}]},
      q2:{ text:"Can you dry the coat properly without your puppy trying hard to escape?",
        opts:[{t:"Yes — no issue",e:"✨",s:3},{t:"Mostly yes, with support",e:"🍖",s:2},{t:"Only briefly",e:"⚡",s:1},{t:"We avoid proper drying",e:"🚫",s:0}]},
      truth:"A calm shorter groom is always better than a beautiful stressful one.",
      consequence:"Long coats that air-dry without brushing through set in tangles that become painful to remove.",
      nextStep:"If drying is the weak point, start with a towel they accept before introducing any airflow at all." },

    { id:"3-5", num:5, icon:"✂️", title:"Maintenance Routine & Professional Support", hideForAge:[1],
      teaser:"Long coats need professional maintenance before they need rescuing.",
      why:"Getting in early means the coat — and the dog — never reach crisis point.",
      q1:{ text:"Has your puppy had an early grooming or maintenance introduction yet?",
        opts:[{t:"Yes — went smoothly",e:"⭐",s:3},{t:"Yes — nervous but manageable",e:"😕",s:2},{t:"Yes — stressful",e:"😢",s:1},{t:"Not yet",e:"📅",s:0}]},
      q2:{ text:"Between maintenance sessions, how is the coat holding up?",
        opts:[{t:"Very manageable, little tangling",e:"✨",s:3},{t:"Some tangles, mostly okay",e:"🙂",s:2},{t:"Regular knotting in problem areas",e:"😬",s:1},{t:"Often knotty or matted by the time we deal with it",e:"⚠️",s:0}]},
      truth:"Long coats can look presentable on the surface while friction zones underneath are already knotting.",
      consequence:"Regular maintenance visits keep the coat — and the dog's comfort — ahead of any issues before they start.",
      nextStep:"Book a tidy and check-over now. Be honest about the coat condition — your groomer can help make a plan." },
  ],

  4: [
    { id:"4-1", num:1, icon:"🤲", title:"Body Handling & Standing Still", hideForAge:[],
      teaser:"No clipping required. Plenty of handling required.",
      why:"Double-coated dogs still have to learn grooming — coat type doesn't change that.",
      q1:{ text:"Can your puppy stand calmly on a secure non-slip surface while you run both hands firmly over their body?",
        opts:[{t:"Yes — very comfortable",e:"✅",s:3},{t:"Wiggly but workable",e:"🙂",s:2},{t:"Moves away or sits quickly",e:"😬",s:1},{t:"We haven't really practised stillness",e:"⏳",s:0}]},
      q2:{ text:"How does your puppy respond to firmer brushing pressure into the coat?",
        opts:[{t:"Totally fine — leans into it",e:"🌟",s:3},{t:"Mostly okay",e:"👍",s:2},{t:"Turns around or resists",e:"😕",s:1},{t:"We only do light brushing",e:"🤷",s:0}]},
      truth:"The coat doesn't need styling, but the handling still needs to be learned — bath, dryer, nails, table.",
      consequence:"A dog who won't stand still for brushing won't stand still for deshedding, nails, or ear checks either.",
      nextStep:"Practise two minutes of calm standing daily on a non-slip mat. Build from body strokes to firm brushing to feet." },

    { id:"4-2", num:2, icon:"👁️", title:"Feet, Nails & Ears", hideForAge:[],
      teaser:"Double-coated dogs need nail and ear work just as much as any other.",
      why:"Nails and ears are the two things most likely to become problems if they're not normalised early.",
      q1:{ text:"Can you hold and examine each paw — spreading toes, touching each nail?",
        opts:[{t:"Yes — all four, no issue",e:"✅",s:3},{t:"Mostly yes, one or two tricky",e:"🤔",s:2},{t:"They pull away most times",e:"😤",s:1},{t:"We avoid foot handling",e:"❌",s:0}]},
      q2:{ text:"Are ear handling and checks part of your regular routine?",
        opts:[{t:"Yes — very normal for them",e:"✅",s:3},{t:"Sometimes",e:"🔄",s:2},{t:"Rarely",e:"😬",s:1},{t:"Not yet",e:"⏳",s:0}]},
      truth:"Most grooming sensitivity in adult dogs comes from a lack of early exposure — not from any single bad experience.",
      consequence:"Nail and ear resistance that starts early tends to escalate without consistent, calm handling.",
      nextStep:"One paw per day, held for 10 seconds, followed by a treat. That's the whole session. Consistency beats force." },

    { id:"4-3", num:3, icon:"🪮", title:"Brush Depth & Undercoat Work", hideForAge:[],
      teaser:"Surface brushing on a double coat is nearly pointless.",
      why:"Undercoat is where this coat type lives — and where the problems hide.",
      q1:{ text:"Are you brushing into the undercoat — not just smoothing the surface?",
        opts:[{t:"Yes — properly into the undercoat",e:"💯",s:3},{t:"Usually, but not always",e:"🙂",s:2},{t:"Mostly surface brushing",e:"😬",s:1},{t:"No real routine yet",e:"🤷",s:0}]},
      q2:{ text:"Does your puppy stay calm long enough for a proper brush-out?",
        opts:[{t:"Yes — comfortably",e:"🏆",s:3},{t:"Mostly, with a few breaks",e:"🙂",s:2},{t:"Struggles fairly quickly",e:"😕",s:1},{t:"Barely tolerates it",e:"😤",s:0}]},
      truth:"Brushing the surface and combing all the way through are two different things — and both matter.",
      consequence:"Undercoat that isn't worked regularly compacts — and a compacted double coat traps heat and moisture against the skin.",
      nextStep:"Get an undercoat rake or deshedding brush this week. Use it firmly and slowly through the full coat, not just the top." },

    { id:"4-4", num:4, icon:"💨", title:"Bath & Dryer Exposure", hideForAge:[],
      teaser:"The dryer is the bigger hurdle for this coat type. Start there.",
      why:"Force dryers are the most effective tool for double coats — and the one dogs most fear if not introduced early.",
      q1:{ text:"Has your puppy been introduced to dryer sound near them?",
        opts:[{t:"Yes — completely unbothered",e:"😎",s:3},{t:"Nervous but coping",e:"😐",s:2},{t:"Clearly frightened",e:"😰",s:1},{t:"Not yet",e:"❌",s:0}]},
      q2:{ text:"Can airflow touch the coat while your puppy stays reasonably calm?",
        opts:[{t:"Yes — no issue",e:"✨",s:3},{t:"Yes — with support",e:"🍖",s:2},{t:"Only very briefly",e:"⚡",s:1},{t:"Not yet",e:"🤔",s:0}]},
      truth:"Drying tolerance is taught, not built in — and it's never too late to introduce it gradually.",
      consequence:"A double-coated dog who fears the dryer is much harder and slower to deshed — and the coat suffers for it.",
      nextStep:"Dryer on in another room — just the sound, treats throughout. Move closer over several sessions. Never rush." },

    { id:"4-5", num:5, icon:"🛁", title:"Bath & Deshed Routine", hideForAge:[1],
      teaser:"One professional deshed session removes more undercoat than weeks of home brushing.",
      why:"A routine in place early keeps the coat manageable and the dog comfortable with the process.",
      q1:{ text:"Has your puppy had a professional bath-and-dry introduction yet?",
        opts:[{t:"Yes — went well",e:"✅",s:3},{t:"Yes — a bit stressful but manageable",e:"😕",s:2},{t:"Yes — clearly stressful",e:"😢",s:1},{t:"Not yet",e:"📅",s:0}]},
      q2:{ text:"Do you have a predictable brush-out or deshed routine in place?",
        opts:[{t:"Yes — very consistent",e:"📆",s:3},{t:"Somewhat consistent",e:"🔄",s:2},{t:"Only when the shedding gets bad",e:"🤷",s:1},{t:"Not really",e:"🚫",s:0}]},
      truth:"'No haircut' is where a lot of owners mentally switch off. That is usually the mistake.",
      consequence:"Double coats without routine deshedding shed more, mat in spots, and become harder to manage over time.",
      nextStep:"Book a professional bath-and-blow-dry. Tell them it's for deshedding and handling exposure — not styling." },
  ],

  5: [
    { id:"5-1", num:1, icon:"🤲", title:"Body Handling Foundation", hideForAge:[],
      teaser:"The coat is simple. The handling still isn't optional.",
      why:"Short-coated dogs who miss handling early become hard dogs to examine, treat, and groom.",
      q1:{ text:"How comfortable is your puppy with full-body handling at home?",
        opts:[{t:"Very comfortable — no issue",e:"✅",s:3},{t:"Mostly okay, a bit wiggly",e:"🙂",s:2},{t:"Sensitive or resistant in places",e:"😬",s:1},{t:"We haven't really worked on this",e:"⏳",s:0}]},
      q2:{ text:"Can you gently check the ears, mouth, belly, and tail without a struggle?",
        opts:[{t:"Yes — very normal",e:"🌟",s:3},{t:"Mostly yes",e:"👍",s:2},{t:"Some parts are hard",e:"😕",s:1},{t:"We avoid it",e:"🚫",s:0}]},
      truth:"The coat is simple. The handling tolerance — nails, ears, baths, restraint — is where the early work pays off.",
      consequence:"Short coats that weren't handled early still become dogs who fight nail clips and ear cleans for life.",
      nextStep:"This week: ears, mouth, belly, tail — every day, one at a time, with treats. Very short, very calm." },

    { id:"5-2", num:2, icon:"🦶", title:"Feet & Nails", hideForAge:[],
      teaser:"This is the whole game for short-coated dogs. Nails matter for their whole life.",
      why:"Overgrown nails affect posture and gait quietly — most owners don't notice until it's a real problem.",
      q1:{ text:"Can you hold each paw, separate the toes, and touch each nail?",
        opts:[{t:"Yes — calmly every time",e:"✅",s:3},{t:"Mostly yes, one or two resist",e:"🤔",s:2},{t:"They pull away every time",e:"😤",s:1},{t:"We avoid nail handling",e:"❌",s:0}]},
      q2:{ text:"Has your puppy had a nail trim or nail-introduction routine?",
        opts:[{t:"Yes — regularly, they cope fine",e:"✂️",s:3},{t:"Yes — a little stressful but done",e:"😬",s:2},{t:"Tried but couldn't get through it",e:"😓",s:1},{t:"Not yet",e:"⏳",s:0}]},
      truth:"I can usually tell very quickly whether the handling work started early.",
      consequence:"Nail resistance that starts early and goes unaddressed usually gets worse — not better — without consistent work.",
      nextStep:"One paw. Ten seconds. One treat. That is the full session. Four times this week before trying more." },

    { id:"5-3", num:3, icon:"🛁", title:"Bath & Drying", hideForAge:[],
      teaser:"Short coats still need to find bath time completely normal.",
      why:"A dog who fights baths or drying is harder to examine, harder to treat, and harder to groom for life.",
      q1:{ text:"How does your puppy handle bath time?",
        opts:[{t:"Calm and completely normal",e:"😌",s:3},{t:"Tolerates it with some fidgeting",e:"🙂",s:2},{t:"Clearly stressed",e:"😕",s:1},{t:"It becomes a battle",e:"😤",s:0}]},
      q2:{ text:"How do they cope with drying?",
        opts:[{t:"Fine with towel and airflow",e:"✨",s:3},{t:"Towel yes, airflow is harder",e:"🤔",s:2},{t:"Both are difficult",e:"😬",s:1},{t:"We skip it and let them air-dry",e:"🤷",s:0}]},
      truth:"A simple coat still needs bath tolerance, nail handling, and a dog who's comfortable being handled all over.",
      consequence:"Bath and drying resistance becomes a vet problem as much as a grooming problem.",
      nextStep:"Next bath: under three minutes. Warm water, non-slip mat, treats throughout. Goal is calm — not clean." },

    { id:"5-4", num:4, icon:"🏠", title:"Stillness & Surface Confidence", hideForAge:[],
      teaser:"A dog who can stand still and be handled safely is a dog who can be cared for properly.",
      why:"Stillness on a surface is the foundation for every vet check and grooming appointment this dog will ever have.",
      q1:{ text:"Can your puppy stand briefly on a secure non-slip surface while being handled?",
        opts:[{t:"Yes — calmly",e:"🌟",s:3},{t:"Wiggly but manageable",e:"🙂",s:2},{t:"Tries hard to get away",e:"😬",s:1},{t:"We've never practised this",e:"🤷",s:0}]},
      q2:{ text:"Can you support them in brief stillness for a few seconds without panic?",
        opts:[{t:"Yes — easily",e:"✅",s:3},{t:"Some wriggling but workable",e:"😐",s:2},{t:"Strong resistance",e:"😤",s:1},{t:"Not really attempted yet",e:"⏳",s:0}]},
      truth:"Wriggling is normal. Full survival-mode behaviour is not.",
      consequence:"A dog who panics on any raised surface is a safety risk at every future appointment.",
      nextStep:"Put them on a non-slip mat on the floor first — not a table. Stand, reward, off. That's the whole session." },

    { id:"5-5", num:5, icon:"🏥", title:"Stranger Handling & Vet Readiness", hideForAge:[],
      ageHelper:{ 1:"At this age, even brief calm exposure counts — this does not need to be perfect yet." },
      teaser:"Being calm with strangers is a life skill, not just a grooming skill.",
      why:"A dog who can only be handled by their owner will struggle at every vet visit for the rest of their life.",
      q1:{ text:"Can someone outside the immediate family handle your puppy without major resistance?",
        opts:[{t:"Yes — they cope really well",e:"🏆",s:3},{t:"A little unsure but manageable",e:"🙂",s:2},{t:"Quite difficult with strangers",e:"😕",s:1},{t:"We haven't really tested this yet",e:"⏳",s:0}]},
      q2:{ text:"Has your puppy had a calm professional handling moment — nails, ears, bath, or routine checks?",
        opts:[{t:"Yes — and it went well",e:"✅",s:3},{t:"Yes — they were nervous",e:"😐",s:2},{t:"Yes — and it was hard",e:"😬",s:1},{t:"Not yet",e:"📅",s:0}]},
      truth:"Most grooming sensitivity in adult dogs comes from a lack of early exposure — not from any single bad experience.",
      consequence:"Dogs not handled by strangers early often become harder at the vet and groomer — not occasionally, but as a pattern.",
      nextStep:"Ask a friend or family member to handle your puppy this week. Brief, calm, treat-paired. Keep it positive." },
  ],
};
  var CATCHUP = {
  1:{ 1:"You're in the golden window. Start now and this will be easy. Daily chin holds, paw touches, brush contact, dryer sound at a distance. Everything you build now pays off for 15 years.",
      2:"Book a salon intro this week if you haven't. At home: chin hold, feet, face, comb through — five minutes daily. The coat is growing. The habits need to keep up.",
      3:"This is the last real window. Book a comfort-first appointment and stop trying to save coat length if it's behind. A calm short clip beats a beautiful stressed dog.",
      4:"You haven't ruined your dog. But yes — this is harder now. The goal is no longer perfect foundations. It's rebuilding tolerance and routine. A skilled groomer can break appointments into smaller, more manageable pieces." },
  2:{ 1:"Start the same foundation work as a curly coat. The margin for error is slightly wider — not magically wide.",
      2:"Establish the routine now before the coat starts behaving more like a maintenance problem than a cute puppy coat.",
      3:"This is where fleece owners realise they were further behind than they thought. Prioritise comfort over style from here.",
      4:"Still workable. Don't wait for coat change and hidden tangles to force the reset for you." },
  3:{ 1:"Start the daily habit now. Keep it tiny. Ears, chest, feathering, belly, legs. Short and boring is exactly what you want.",
      2:"Friction knots begin here if the routine is patchy. Comb problem zones daily and get maintenance support before discomfort builds.",
      3:"If knots are forming, don't turn home brushing into a wrestling match. Get the coat reset professionally, then maintain little and often.",
      4:"Long coats that fall behind often look better than they feel. Get honest about the actual coat condition and rebuild from there." },
  4:{ 1:"Start with handling, brushing contact, and dryer sound. This coat doesn't need styling — but it absolutely needs training.",
      2:"Now is the time to make bath-and-dry normal. The coat may not look urgent yet, but the sensory learning matters now.",
      3:"If dryer tolerance hasn't been built, treat it as urgent. Ask your groomer for a dryer-introduction session before a full deshed.",
      4:"A professional deshed can still make a real difference. But handling tolerance has to be rebuilt consistently — not occasionally." },
  5:{ 1:"Start with hands on body, ears, mouth, feet, and nails. Short-coated puppies often get less prep than they need because owners assume they're low-maintenance.",
      2:"Keep nail work, bath work, and stranger handling normal and boring. This track doesn't need styling, but it absolutely needs tolerance.",
      3:"If nail trims or restraint are already a fight, stop making it a once-in-a-while battle. Tiny daily reps beat occasional forced sessions every time.",
      4:"These dogs can still improve a lot, but you need to be consistent and realistic. Handling tolerance is the goal — not just 'getting it done somehow'." },
};
  var RESULT_COPY = {
  strong:   "You're building the right things early. Keep going. The goal isn't a flawless puppy — it's a puppy who learns grooming is normal, safe, and repeatable.",
  ontrack:  "You have a workable base, but there are gaps that will matter more later if they stay untouched. Tighten the routine now while the learning is still easier.",
  catchup:  "You're not too late, but you're behind in areas that can snowball fast. Start with the weakest milestone and make it small, daily, and realistic.",
  startnow: "This doesn't mean disaster. It means there's not much routine in place yet. That's fixable — but only if you stop waiting for the perfect time and begin now.",
};

  var COAT_SHORT = {
    1: "Fast-matting. The most unforgiving coat if early grooming is skipped.",
    2: "Softer than wool — but still demands the same early work.",
    3: "Looks innocent. Knots fast in friction zones once routine slips.",
    4: "No clipping needed. Dryer tolerance and brush depth still must be built.",
    5: "Lowest coat maintenance. Nail, bath, and restraint tolerance still matter."
  };

  var COAT_EXAMPLES_SHORT = {
    1: "Cavoodle, Goldendoodle, Poodle, Cockapoo",
    2: "Some Groodles, some Labradoodles, Bordoodle",
    3: "Maltese, Shih Tzu, Cavalier KCS, Yorkie",
    4: "Labrador, Golden Retriever, Husky, Kelpie",
    5: "Staffy, French Bulldog, Beagle, Boxer"
  };

  var PRODUCT_CTA = {
    1: { headline:"Built for exactly the coat you just assessed.", sub:"The Dogify Oodle Kit was developed and tested in-salon for curly and wool coats.", label:"Shop the Oodle Kit →" },
    2: { headline:"Built for exactly the coat you just assessed.", sub:"The Dogify Oodle Kit works beautifully on wavy and fleece coats too — it's what we use in salon.", label:"Shop the Oodle Kit →" },
    3: { headline:"The right tools make the daily routine possible.", sub:"Shop the Dogify range — built for dogs who need regular home maintenance.", label:"Shop Dogify for Silky Coats →" },
    4: { headline:"The right brush changes everything for this coat.", sub:"Shop the Dogify range — designed for dogs who need real undercoat work at home.", label:"Shop Dogify for Double Coats →" },
    5: { headline:"Simple coat. The tools still matter.", sub:"Shop the Dogify range — because nails, ears, and baths still need the right equipment.", label:"Shop Dogify for Short Coats →" }
  };

  var state = {
    screen: 'intake',
    ageWindow: null,
    coatTrack: null,
    mIdx: 0,
    subPhase: 'scratch',
    q1Score: null,
    q2Score: null,
    q1Sel: null,
    q2Sel: null,
    allScores: {},
    email: '',
    submitted: false
  };

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getActiveMilestones(trackId, ageWindowId) {
    return (MILESTONES[trackId] || []).filter(function(m) {
      return !m.hideForAge.includes(ageWindowId);
    });
  }

  function getGrade(score) {
    if (score >= 5) return { label:"Strong", key:"strong", color:"#1A6B6C", bg:"#E8F2F2", border:"#1A6B6C" };
    if (score >= 3) return { label:"Building", key:"building", color:"#8A6B1A", bg:"#FBF5DC", border:"#8A6B1A" };
    if (score >= 1) return { label:"Behind", key:"behind", color:"#bc6688", bg:"#FDF0F4", border:"#D47A9A" };
    return { label:"Not started", key:"not-started", color:"#555", bg:"#F0F0F0", border:"#CCC" };
  }

  function getOverall(pct) {
    if (pct >= 85) return { label:"Strong foundations", key:"strong", color:"#1A6B6C", className:"" };
    if (pct >= 65) return { label:"On track", key:"ontrack", color:"#8A6B1A", className:"is-ontrack" };
    if (pct >= 40) return { label:"Catch-up needed", key:"catchup", color:"#D47A9A", className:"is-catchup" };
    return { label:"Start now", key:"startnow", color:"#bc6688", className:"is-startnow" };
  }

  function getComputed() {
    var activeMilestones = state.coatTrack && state.ageWindow ? getActiveMilestones(state.coatTrack, state.ageWindow) : [];
    var milestone = activeMilestones[state.mIdx] || null;
    var totalPts = activeMilestones.length * 6;
    var earnedPts = Object.keys(state.allScores).reduce(function(acc, key) {
      return acc + (state.allScores[key] || 0);
    }, 0);
    var pct = totalPts > 0 ? Math.round((earnedPts / totalPts) * 100) : 0;
    var overall = getOverall(pct);
    var coatData = COAT_TRACKS.find(function(ct) { return ct.id === state.coatTrack; }) || null;
    var ageData = AGE_WINDOWS.find(function(aw) { return aw.id === state.ageWindow; }) || null;
    var milestoneScore = milestone ? (state.allScores[milestone.id] != null ? state.allScores[milestone.id] : null) : null;
    var grade = milestoneScore != null ? getGrade(milestoneScore) : null;
    var progressPct = activeMilestones.length > 0 ? (state.mIdx / activeMilestones.length) * 100 : 0;
    var weakest = null;
    activeMilestones.forEach(function(m) {
      var s = state.allScores[m.id] != null ? state.allScores[m.id] : 6;
      if (!weakest) {
        weakest = m;
        return;
      }
      var weakestScore = state.allScores[weakest.id] != null ? state.allScores[weakest.id] : 6;
      if (s < weakestScore) weakest = m;
    });
    return {
      activeMilestones: activeMilestones,
      milestone: milestone,
      totalPts: totalPts,
      earnedPts: earnedPts,
      pct: pct,
      overall: overall,
      coatData: coatData,
      ageData: ageData,
      milestoneScore: milestoneScore,
      grade: grade,
      progressPct: progressPct,
      weakest: weakest
    };
  }

  function smoothTop() {
    var app = root.querySelector('.dlpr-app');
    if (app && app.scrollIntoView) {
      app.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function renderIntake() {
    var stepAgeDone = !!state.ageWindow;
    var stepCoatDone = !!state.coatTrack;
    var ageHtml = AGE_WINDOWS.map(function(aw) {
      var active = state.ageWindow === aw.id;
      return `
        <button class="dlpr-choice ${active ? 'is-active' : ''}" type="button" data-action="select-age" data-id="${aw.id}">
          <div class="dlpr-choice__row">
            <div class="dlpr-choice__left">
              ${active ? '<span class="dlpr-choice__check">✓</span>' : ''}
              <p class="dlpr-choice__label">${escapeHtml(aw.label)}</p>
            </div>
            <span class="dlpr-choice__tag">${escapeHtml(aw.tag)}</span>
          </div>
          <p class="dlpr-choice__desc">${escapeHtml(aw.desc)}</p>
        </button>
      `;
    }).join('');

    var coatHtml = state.ageWindow ? COAT_TRACKS.map(function(ct) {
      var active = state.coatTrack === ct.id;
      return `
        <button class="dlpr-coat-card ${active ? 'is-active' : ''}" type="button" data-action="select-coat" data-id="${ct.id}">
          <div class="dlpr-coat-card__row">
            <div class="dlpr-coat-card__icon dlpr-coat-card__icon--${ct.id}">${ct.icon}</div>
            <div class="dlpr-coat-card__main">
              <div class="dlpr-coat-card__top">
                <p class="dlpr-coat-card__title">${escapeHtml(ct.name)}</p>
                ${active ? '<span class="dlpr-choice__check">✓</span>' : ''}
              </div>
              <p class="dlpr-coat-card__summary">${escapeHtml(COAT_SHORT[ct.id])}</p>
              ${active ? `<p class="dlpr-coat-card__examples">e.g. ${escapeHtml(COAT_EXAMPLES_SHORT[ct.id])}</p>` : ''}
            </div>
          </div>
        </button>
      `;
    }).join('') : '';

    var summary = '';
    if (state.ageWindow && state.coatTrack) {
      var ageData = AGE_WINDOWS.find(function(a) { return a.id === state.ageWindow; });
      var coatData = COAT_TRACKS.find(function(c) { return c.id === state.coatTrack; });
      summary = `
        <div class="dlpr-center dlpr-mb-14">
          <div class="dlpr-pill">
            <span class="dlpr-text-teal"><strong>${escapeHtml(ageData.label)}</strong></span>
            <span class="dlpr-pill__dot">·</span>
            <span class="dlpr-text-teal"><strong>${escapeHtml(coatData.name)}</strong></span>
          </div>
        </div>
      `;
    }

    return `
      <div class="dlpr-app">
        <div class="dlpr-wrap">
          <div class="dlpr-hero dlpr-center">
            <p class="dlpr-eyebrow dlpr-mb-14">Dog Love · Puppy Roadmap</p>
            <h1 class="dlpr-title dlpr-mb-10">How is your puppy&#39;s<br><span class="dlpr-italic-pink">first year going?</span></h1>
            <p class="dlpr-copy dlpr-mb-20">Scratch through 5 milestones and see exactly what to focus on next.</p>

            <div class="dlpr-stepper">
              <div class="dlpr-stepper__item">
                <div class="dlpr-stepper__core">
                  <div class="dlpr-stepper__dot ${!state.ageWindow ? 'is-current' : 'is-done'}">${state.ageWindow ? '✓' : '1'}</div>
                  <span class="dlpr-stepper__label ${!state.ageWindow ? 'is-current' : (stepAgeDone ? 'is-done' : '')}">Age</span>
                </div>
                <div class="dlpr-stepper__line ${stepAgeDone ? 'is-done' : ''}"></div>
              </div>
              <div class="dlpr-stepper__item">
                <div class="dlpr-stepper__core">
                  <div class="dlpr-stepper__dot ${state.ageWindow && !state.coatTrack ? 'is-current' : (stepCoatDone ? 'is-done' : '')}">${stepCoatDone ? '✓' : '2'}</div>
                  <span class="dlpr-stepper__label ${state.ageWindow && !state.coatTrack ? 'is-current' : (stepCoatDone ? 'is-done' : '')}">Coat</span>
                </div>
                <div class="dlpr-stepper__line ${stepCoatDone ? 'is-done' : ''}"></div>
              </div>
              <div class="dlpr-stepper__item">
                <div class="dlpr-stepper__core">
                  <div class="dlpr-stepper__dot ${state.ageWindow && state.coatTrack ? 'is-current' : ''}">3</div>
                  <span class="dlpr-stepper__label ${state.ageWindow && state.coatTrack ? 'is-current' : ''}">Quiz</span>
                </div>
              </div>
            </div>
          </div>

          <div class="dlpr-mt-28">
            <p class="dlpr-kicker dlpr-mb-10">Step 1 — How old is your puppy?</p>
            <div class="dlpr-picker">${ageHtml}</div>
          </div>

          ${state.ageWindow ? `
            <div class="dlpr-mt-32 dlpr-fadeup">
              <p class="dlpr-kicker dlpr-mb-4">Step 2 — What coat is your puppy?</p>
              <p class="dlpr-copy dlpr-copy--small dlpr-copy--italic dlpr-mb-12">Choose the coat they&#39;re growing into. Mixed breeds often sit between tracks.</p>
              <div class="dlpr-coat-list">${coatHtml}</div>
            </div>
          ` : ''}

          ${state.ageWindow && state.coatTrack ? `
            <div class="dlpr-mt-32 dlpr-fadeup">
              ${summary}
              <button class="dlpr-btn dlpr-btn--primary" type="button" data-action="start-quiz">Start puppy assessment →</button>
              <p class="dlpr-copy dlpr-copy--small dlpr-text-center dlpr-mt-10">5 milestones · scratch each one · ~3 minutes</p>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  function renderQuestionCard(questionNum, question, selectedIdx, locked, actionName) {
    var opts = question.opts.map(function(opt, i) {
      var selected = selectedIdx === i;
      var dim = locked && !selected;
      return `
        <button class="dlpr-option ${selected ? 'dlpr-option--selected' : ''} ${dim ? 'dlpr-option--dim' : ''}" type="button" data-action="${actionName}" data-score="${opt.s}" data-index="${i}">
          <span class="dlpr-option__radio">${selected ? '<span>✓</span>' : ''}</span>
          <span class="dlpr-option__label">${escapeHtml(opt.t)}</span>
        </button>
      `;
    }).join('');
    return `
      <div class="dlpr-question-card dlpr-fadeup">
        <div class="dlpr-question-card__head">
          <p class="dlpr-kicker dlpr-kicker--pink dlpr-mb-6">Question ${questionNum}</p>
          <p class="dlpr-question-card__title">${escapeHtml(question.text)}</p>
        </div>
        <div>${opts}</div>
      </div>
    `;
  }

  function renderQuiz(comp) {
    var milestone = comp.milestone;
    var grade = comp.grade;
    var scoreClass = grade ? grade.key : '';
    return `
      <div class="dlpr-app">
        <div class="dlpr-quiz-header">
          <div class="dlpr-quiz-header__inner">
            <div class="dlpr-quiz-header__top">
              <button class="dlpr-btn dlpr-btn--back" type="button" data-action="back">← Back</button>
              <p class="dlpr-quiz-header__count">${state.mIdx + 1} <span>of ${comp.activeMilestones.length}</span></p>
              <div class="dlpr-quiz-pill">
                <span>${comp.coatData ? comp.coatData.icon : ''}</span>
                <span>${comp.coatData ? escapeHtml(comp.coatData.name) : ''}</span>
              </div>
            </div>
            <div class="dlpr-progress">
              <div class="dlpr-progress__bar" style="width:${comp.progressPct}%"></div>
            </div>
          </div>
        </div>

        <div class="dlpr-wrap dlpr-stack-14">
          <div class="dlpr-scratch dlpr-mt-20">
            <div class="dlpr-scratch__body">
              <p class="dlpr-eyebrow dlpr-mb-8">Milestone ${milestone.num} of ${comp.activeMilestones.length}</p>
              <p class="dlpr-title dlpr-title--md">${escapeHtml(milestone.title)}</p>
              <p class="dlpr-scratch__teaser">${escapeHtml(milestone.teaser)}</p>
              <p class="dlpr-scratch__why">${escapeHtml(milestone.why)}</p>
              ${milestone.ageHelper && milestone.ageHelper[state.ageWindow] ? `<div class="dlpr-scratch__helper">${escapeHtml(milestone.ageHelper[state.ageWindow])}</div>` : ''}
            </div>
            ${state.subPhase === 'scratch' ? '<canvas class="dlpr-scratch__canvas" id="dlpr-scratch-canvas"></canvas>' : ''}
          </div>

          ${state.subPhase === 'scratch' ? '<p class="dlpr-scratch__hint dlpr-pulse">Drag your finger across the card to reveal</p>' : ''}
          ${state.subPhase === 'q1' ? '<p class="dlpr-copy dlpr-copy--small dlpr-copy--italic dlpr-text-center dlpr-fadeup">There are no wrong answers here — just honest ones.</p>' : ''}

          ${['q1','q2','result'].includes(state.subPhase) ? renderQuestionCard(1, milestone.q1, state.q1Sel, state.q1Score !== null, 'answer-q1') : ''}
          ${['q2','result'].includes(state.subPhase) ? renderQuestionCard(2, milestone.q2, state.q2Sel, state.q2Score !== null, 'answer-q2') : ''}

          ${state.subPhase === 'result' && grade ? `
            <div class="dlpr-stack-10 dlpr-fadeup">
              <div class="dlpr-badge-card dlpr-badge-card--${scoreClass}">
                <div class="dlpr-badge-card__top">
                  <span class="dlpr-badge dlpr-badge--${scoreClass}">${escapeHtml(grade.label)}</span>
                  <span class="dlpr-badge-card__score">Score ${comp.milestoneScore}/6</span>
                </div>
                <p class="dlpr-title dlpr-title--sm">${escapeHtml(milestone.title)}</p>
              </div>

              <div class="dlpr-note dlpr-note--teal">
                <div class="dlpr-note__top">
                  <p class="dlpr-note__label dlpr-note__label--teal">Groomer&#39;s note</p>
                  <span class="dlpr-note__meta">· no judgement</span>
                </div>
                <p class="dlpr-note__quote">&ldquo;${escapeHtml(milestone.truth)}&rdquo;</p>
              </div>

              ${comp.milestoneScore < 5 ? `
                <div class="dlpr-note dlpr-note--pink">
                  <p class="dlpr-note__label dlpr-note__label--pink dlpr-mb-6">${comp.milestoneScore >= 3 ? 'Keep building' : 'How to catch up'}</p>
                  ${comp.milestoneScore < 3 ? `<p class="dlpr-note__body">${escapeHtml(milestone.consequence)}</p>` : ''}
                  <p class="dlpr-note__body"><strong>${escapeHtml(milestone.nextStep)}</strong></p>
                </div>
              ` : '<p class="dlpr-copy dlpr-copy--small dlpr-copy--italic dlpr-text-center dlpr-text-teal">This one&#39;s solid. Keep the habit going.</p>'}

              <button class="dlpr-btn dlpr-btn--primary" type="button" data-action="next-milestone">${state.mIdx < comp.activeMilestones.length - 1 ? 'Next milestone →' : 'See my results →'}</button>
            </div>
          ` : ''}
        </div>
      </div>
    `;
  }

  function renderResults(comp) {
    var breakdown = comp.activeMilestones.map(function(m) {
      var sc = state.allScores[m.id] != null ? state.allScores[m.id] : 0;
      var gr = getGrade(sc);
      return `
        <div class="dlpr-breakdown-card">
          <div class="dlpr-breakdown-card__top">
            <div>
              <p class="dlpr-breakdown-card__title">${escapeHtml(m.title)}</p>
              <p class="dlpr-breakdown-card__meta">Milestone ${m.num}</p>
            </div>
            <span class="dlpr-badge dlpr-badge--${gr.key}">${escapeHtml(gr.label)}</span>
          </div>
          <div class="dlpr-meter">
            <div class="dlpr-meter__bar" style="width:${(sc / 6) * 100}%; background:linear-gradient(90deg, ${gr.color}, ${gr.color}99);"></div>
          </div>
        </div>
      `;
    }).join('');

    var cta = PRODUCT_CTA[state.coatTrack] || PRODUCT_CTA[1];
    var weakestScore = comp.weakest ? (state.allScores[comp.weakest.id] != null ? state.allScores[comp.weakest.id] : 6) : 6;

    return `
      <div class="dlpr-app">
        <div class="dlpr-results-hero">
          <p class="dlpr-eyebrow dlpr-mb-20">Assessment complete</p>
          <div class="dlpr-score-orb"><span class="dlpr-score-orb__num">${comp.pct}%</span></div>
          <h2 class="dlpr-title dlpr-title--lg dlpr-mb-6">Your puppy&#39;s first year score</h2>
          <p class="dlpr-overall-label ${comp.overall.className}">${escapeHtml(comp.overall.label)}</p>
          <p class="dlpr-copy dlpr-copy--small dlpr-mt-10">
            <span class="dlpr-pill">${escapeHtml(comp.ageData ? comp.ageData.tag : '')} · ${comp.coatData ? comp.coatData.icon : ''} ${escapeHtml(comp.coatData ? comp.coatData.name : '')}</span>
          </p>
        </div>

        <div class="dlpr-wrap">
          <div class="dlpr-card dlpr-card__body dlpr-mb-20" style="border-left:3px solid ${comp.overall.color};">
            <p class="dlpr-copy dlpr-copy--dark">${escapeHtml(RESULT_COPY[comp.overall.key])}</p>
          </div>

          <p class="dlpr-kicker dlpr-mb-12">Milestone breakdown</p>
          <div class="dlpr-breakdown-list dlpr-mb-24">${breakdown}</div>

          ${CATCHUP[state.coatTrack] && CATCHUP[state.coatTrack][state.ageWindow] ? `
            <div class="dlpr-mb-20">
              <p class="dlpr-kicker dlpr-kicker--pink dlpr-mb-12">Where to focus now</p>
              <div class="dlpr-note dlpr-note--pink">
                <p class="dlpr-note__body">${escapeHtml(CATCHUP[state.coatTrack][state.ageWindow])}</p>
              </div>
            </div>
          ` : ''}

          ${comp.weakest && weakestScore < 5 ? `
            <div class="dlpr-mb-20">
              <p class="dlpr-kicker dlpr-mb-12">Start here this week</p>
              <div class="dlpr-card dlpr-card__body">
                <p class="dlpr-copy dlpr-copy--small dlpr-text-muted dlpr-mb-8"><strong>${comp.weakest.icon} ${escapeHtml(comp.weakest.title)}</strong></p>
                <p class="dlpr-copy dlpr-copy--dark">${escapeHtml(comp.weakest.nextStep)}</p>
              </div>
            </div>
          ` : ''}

          <div class="dlpr-note dlpr-note--teal dlpr-mb-24">
            <p class="dlpr-kicker dlpr-kicker--teal dlpr-mb-8">From the grooming table</p>
            <p class="dlpr-note__quote">&ldquo;A puppy is not a phase. It is the beginning of your dog&#39;s relationship with handling — by you, by groomers, and by vets. What you build in the first year matters. Not perfectly. But significantly.&rdquo;</p>
          </div>

          <div class="dlpr-email-card dlpr-mb-16">
            ${state.submitted ? `
              <div class="dlpr-center">
                <p class="dlpr-text-white dlpr-mb-8" style="font-size:22px;">✓</p>
                <p class="dlpr-title dlpr-title--sm" style="color:#fff;">We&#39;ll reach out before the next milestone matters.</p>
              </div>
            ` : `
              <p class="dlpr-title dlpr-title--sm dlpr-text-white dlpr-mb-8">Get your milestone reminders.</p>
              <p class="dlpr-copy dlpr-copy--white-muted dlpr-copy--small dlpr-mb-16">We&#39;ll reach out before each one matters — so nothing gets missed.</p>
              <input class="dlpr-field dlpr-mb-10" type="email" data-action="email-input" placeholder="your@email.com.au" value="${escapeHtml(state.email)}">
              <button class="dlpr-btn ${state.email ? 'dlpr-btn--primary' : 'dlpr-btn--muted'}" type="button" data-action="submit-email">Send my roadmap →</button>
              <p class="dlpr-copy dlpr-copy--tiny dlpr-copy--white-muted dlpr-text-center dlpr-mt-10">From Dog Love. No spam — just the right info at the right time.</p>
            `}
          </div>

          <div class="dlpr-product-card dlpr-mb-12">
            <p class="dlpr-title dlpr-title--sm dlpr-mb-8">${escapeHtml(cta.headline)}</p>
            <p class="dlpr-copy dlpr-copy--small dlpr-mb-16">${escapeHtml(cta.sub)}</p>
            <a class="dlpr-product-link" href="https://dogloveservices.com.au" target="_blank" rel="noreferrer">${escapeHtml(cta.label)}</a>
          </div>

          <div class="dlpr-center dlpr-mb-20">
            <p class="dlpr-copy dlpr-copy--small dlpr-text-teal">
              Based in Adelaide?
              <a class="dlpr-inline-link" href="https://dogloveservices.com.au/services" target="_blank" rel="noreferrer">Book grooming or daycare at Dog Love →</a>
            </p>
          </div>

          <div class="dlpr-center">
            <button class="dlpr-btn dlpr-btn--link" type="button" data-action="start-over">Start over</button>
          </div>
        </div>
      </div>
    `;
  }

  function render() {
    var comp = getComputed();
    if (state.screen === 'intake') {
      root.innerHTML = renderIntake();
    } else if (state.screen === 'quiz' && comp.milestone) {
      root.innerHTML = renderQuiz(comp);
      initScratchCard();
    } else {
      root.innerHTML = renderResults(comp);
    }
  }

  function initScratchCard() {
    if (state.subPhase !== 'scratch') return;
    var canvas = root.querySelector('#dlpr-scratch-canvas');
    if (!canvas) return;

    var drawing = false;
    var done = false;

    function resizeAndPaint() {
      var w = canvas.offsetWidth || 360;
      var h = canvas.offsetHeight || 170;
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      var g = ctx.createLinearGradient(0, 0, w, h);
      g.addColorStop(0, '#1A6B6C');
      g.addColorStop(0.55, '#1E8082');
      g.addColorStop(1, '#D47A9A');
      ctx.fillStyle = g;
      ctx.fillRect(0, 0, w, h);
      for (var i = 0; i < 40; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * w, Math.random() * h, Math.random() * 4 + 1, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,255,255,0.06)';
        ctx.fill();
      }
      ctx.fillStyle = 'rgba(255,255,255,0.88)';
      ctx.font = "600 15px 'DM Sans',sans-serif";
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('✦  Scratch to reveal  ✦', w / 2, h / 2 - 12);
      ctx.font = "400 12px 'DM Sans',sans-serif";
      ctx.fillStyle = 'rgba(255,255,255,0.55)';
      ctx.fillText('drag your finger across the card', w / 2, h / 2 + 14);
    }

    function reveal() {
      if (done) return;
      done = true;
      state.subPhase = 'q1';
      render();
    }

    function scratch(x, y) {
      if (done) return;
      var ctx = canvas.getContext('2d');
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(x, y, 38, 0, Math.PI * 2);
      ctx.fill();

      var d = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      var cleared = 0;
      for (var i = 3; i < d.length; i += 16) {
        if (d[i] < 128) cleared++;
      }
      if (cleared / (d.length / 16) > 0.42) {
        reveal();
      }
    }

    function getPoint(ev) {
      var rect = canvas.getBoundingClientRect();
      if (ev.touches && ev.touches[0]) {
        return {
          x: ev.touches[0].clientX - rect.left,
          y: ev.touches[0].clientY - rect.top
        };
      }
      return {
        x: ev.clientX - rect.left,
        y: ev.clientY - rect.top
      };
    }

    resizeAndPaint();
    window.setTimeout(resizeAndPaint, 40);

    canvas.addEventListener('mousedown', function() { drawing = true; });
    canvas.addEventListener('mouseup', function() { drawing = false; });
    canvas.addEventListener('mouseleave', function() { drawing = false; });
    canvas.addEventListener('mousemove', function(ev) {
      if (!drawing) return;
      var p = getPoint(ev);
      scratch(p.x, p.y);
    });

    canvas.addEventListener('touchstart', function() { drawing = true; }, { passive: true });
    canvas.addEventListener('touchend', function() { drawing = false; }, { passive: true });
    canvas.addEventListener('touchmove', function(ev) {
      ev.preventDefault();
      if (!drawing) return;
      var p = getPoint(ev);
      scratch(p.x, p.y);
    }, { passive: false });
  }

  root.addEventListener('click', function(ev) {
    var trigger = ev.target.closest('[data-action]');
    if (!trigger) return;

    var action = trigger.getAttribute('data-action');
    var comp = getComputed();

    if (action === 'select-age') {
      state.ageWindow = Number(trigger.getAttribute('data-id'));
      render();
      return;
    }

    if (action === 'select-coat') {
      state.coatTrack = Number(trigger.getAttribute('data-id'));
      render();
      return;
    }

    if (action === 'start-quiz') {
      if (!state.ageWindow || !state.coatTrack) return;
      state.screen = 'quiz';
      state.mIdx = 0;
      state.subPhase = 'scratch';
      state.q1Score = null;
      state.q2Score = null;
      state.q1Sel = null;
      state.q2Sel = null;
      state.allScores = {};
      render();
      return;
    }

    if (action === 'answer-q1') {
      if (state.q1Score !== null) return;
      state.q1Score = Number(trigger.getAttribute('data-score'));
      state.q1Sel = Number(trigger.getAttribute('data-index'));
      render();
      window.setTimeout(function() {
        state.subPhase = 'q2';
        render();
      }, 520);
      return;
    }

    if (action === 'answer-q2') {
      if (state.q2Score !== null) return;
      state.q2Score = Number(trigger.getAttribute('data-score'));
      state.q2Sel = Number(trigger.getAttribute('data-index'));
      if (comp.milestone) {
        state.allScores[comp.milestone.id] = (state.q1Score || 0) + state.q2Score;
      }
      render();
      window.setTimeout(function() {
        state.subPhase = 'result';
        render();
      }, 520);
      return;
    }

    if (action === 'next-milestone') {
      smoothTop();
      if (state.mIdx < comp.activeMilestones.length - 1) {
        state.mIdx += 1;
        state.subPhase = 'scratch';
        state.q1Score = null;
        state.q2Score = null;
        state.q1Sel = null;
        state.q2Sel = null;
        render();
      } else {
        state.screen = 'results';
        render();
      }
      return;
    }

    if (action === 'back') {
      smoothTop();
      if (state.subPhase === 'result') {
        if (comp.milestone) delete state.allScores[comp.milestone.id];
        state.q2Score = null;
        state.q2Sel = null;
        state.subPhase = 'q2';
      } else if (state.subPhase === 'q2') {
        state.q1Score = null;
        state.q1Sel = null;
        state.subPhase = 'q1';
      } else if (state.subPhase === 'q1') {
        state.subPhase = 'scratch';
      } else if (state.subPhase === 'scratch') {
        if (state.mIdx === 0) {
          state.screen = 'intake';
        } else {
          state.mIdx -= 1;
          state.subPhase = 'result';
          state.q1Score = null;
          state.q2Score = null;
          state.q1Sel = null;
          state.q2Sel = null;
        }
      }
      render();
      return;
    }

    if (action === 'submit-email') {
      if (!state.email) return;
      state.submitted = true;
      render();
      return;
    }

    if (action === 'start-over') {
      state.screen = 'intake';
      state.ageWindow = null;
      state.coatTrack = null;
      state.mIdx = 0;
      state.subPhase = 'scratch';
      state.q1Score = null;
      state.q2Score = null;
      state.q1Sel = null;
      state.q2Sel = null;
      state.allScores = {};
      state.email = '';
      state.submitted = false;
      render();
      smoothTop();
      return;
    }
  });

  root.addEventListener('input', function(ev) {
    var target = ev.target;
    if (target.matches('[data-action="email-input"]')) {
      state.email = target.value || '';
    }
  });

  render();
})();